module.exports = __webpack_public_path__ + "img/Bitmap1.86653ec1.png";